import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import columns from "./columns";
import useUserList from "../hooks/useUserList";
import React from "react";
import { useErrorBoundary } from "react-error-boundary";

const style = {
  listContainer: { paddingTop: "8px", height: "77vh", width: "100%" },
  list: { "&:hover": { cursor: "pointer" } },
  actionButton: { opacity: 1 },
} as const;

function UserList() {
  const { loading, userList, error } = useUserList();
  const { showBoundary } = useErrorBoundary();

  React.useEffect(() => {
    if (error) {
      showBoundary(error);
    }
  }, [error, showBoundary]);

  return (
    <>
      <Box data-testid="user-list-table-container" sx={style.listContainer}>
        <DataGrid
          data-testid="user-list-table"
          sx={style.list}
          rows={userList}
          columns={columns}
          autoPageSize
          loading={loading}
          disableRowSelectionOnClick
          slots={{
            toolbar: GridToolbar,
          }}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
        />
      </Box>
    </>
  );
}

export default UserList;
